import React from 'react';
import Hero from '../components/Hero';
import Vision from '../components/Vision';
import Mission from '../components/Mission';
import Solutions from '../components/Solutions';
import Benefits from '../components/Benefits';
import USP from '../components/USP';
import CTA from '../components/CTA';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Vision />
      <Mission />
      <Solutions />
      <Benefits />
      <USP />
      <CTA />
    </>
  );
};

export default HomePage;